// timerBar.js
var TimeBar = pc.createScript('timeBar');
TimeBar.attributes.add("ProgressBar", {type: "entity"});

var progressVal = 0.12;
var timeBarTotalTime;

TimeBar.prototype.initialize = function() {

    TimeBar.instance = this;
    this.progressBarState = false;
    this.checkIsContinue();

    this.element = this.ProgressBar.element;
    this.element.material = this.element.material.clone();
    
    this.setProgress(0.12);
    this.app.on("timeBar:reset", this.resetBar,this);
    this.app.on("timeBar:start", this.startBar,this);
    this.entity.on("destroy", this.OnDestroy,this);
};

TimeBar.prototype.setProgress = function(value) {
    progressVal = pc.math.clamp(value, 0.0, 1);
    this.element.material.alphaTest = progressVal;
};

TimeBar.prototype.update = function(dt) {
    
    if (this.progressBarState) {

        var result = progressVal + (dt / timeBarTotalTime)*0.75;
        this.setProgress(result);
        
        if (progressVal >= 1) {
        progressVal = 0.12;
        } 
    }
};

TimeBar.prototype.pauseBar = function () {
    this.progressBarState = false;
};

TimeBar.prototype.continueBar = function () {
    this.progressBarState = true;
};

TimeBar.prototype.resetBar = function () {
    this.progressBarState = false;
    this.checkIsContinue();
};

TimeBar.prototype.startBar = function (durationTime) {

    this.checkIsContinue();
    this.progressBarState = true;
};

TimeBar.prototype.OnDestroy = function(){

    this.app.off("timeBar:reset", this.resetBar,this);
    this.app.off("timeBar:start", this.startBar,this);
    this.entity.off("destroy", this.OnDestroy,this);
};

TimeBar.prototype.checkIsContinue = function () {

    if (PlayerManager.instance.userData.gameMode == gamePlayMode.Normal) {

        if (localStorage.getItem("interruption") == 1) {
            var backupExtraInfo = JSON.parse(localStorage.getItem("extraInfo"));
            progressVal = parseFloat(backupExtraInfo.lastTimeBar);
        }
        else {
            progressVal = 0.12;
        }
    }
    else {
        progressVal = 0.12;
    }
};


